import React, { useState } from 'react'
import axios from 'axios'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, FormControlLabel, Checkbox, Typography
} from '@material-ui/core'

const COST_TYPES = [
  { value: 'labor', label: 'Labor' },
  { value: 'equipment', label: 'Equipment' },
  { value: 'material', label: 'Materials' },
  { value: 'subcontract', label: 'Subcontractor' },
  { value: 'disposal', label: 'Disposal' }
]

const InlineTemplateCreator = ({ open, onClose, service, url, onCreated }) => {
  const [checked, setChecked] = useState({ labor: true })
  const [saving, setSaving] = useState(false)

  const handleToggle = (type) => {
    setChecked(prev => ({ ...prev, [type]: !prev[type] }))
  }

  const handleSave = async () => {
    setSaving(true)
    const components = COST_TYPES
      .filter(ct => checked[ct.value])
      .map(ct => ({ costType: ct.value, description: '' }))

    try {
      await axios.post(`${url}/api/bid-estimation/service-templates`, {
        serviceId: service.serviceId,
        serviceName: service.serviceName,
        serviceCategory: service.serviceCategory,
        components
      })
      setSaving(false)
      setChecked({ labor: true })
      onCreated()
      onClose()
    } catch (e) {
      setSaving(false)
      console.error('Failed to create template:', e)
      alert('Failed: ' + (e.response?.data?.error || e.message))
    }
  }

  const anyChecked = Object.values(checked).some(Boolean)

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>
        What does "{service?.serviceName}" need?
      </DialogTitle>
      <DialogContent>
        <Typography variant='body2' color='textSecondary' style={{ marginBottom: 12 }}>
          Select the cost component types. This creates a reusable template for all future projects.
        </Typography>
        {COST_TYPES.map(ct => (
          <FormControlLabel
            key={ct.value}
            control={<Checkbox checked={!!checked[ct.value]} onChange={() => handleToggle(ct.value)} color='primary' />}
            label={ct.label}
            style={{ display: 'block' }}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} color='primary' variant='contained'
          disabled={!anyChecked || saving}>
          {saving ? 'Saving...' : 'Create Template'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default InlineTemplateCreator
